import { Component, Input, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { SagView } from '@store/models';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-clientcases',
    templateUrl: './clientcases.component.html',
    styleUrls: ['./clientcases.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ClientcasesComponent {
    @Input() sager: SagView[];
    @Input() sidebarCollapsed: boolean;
    @Output() openClientCase = new EventEmitter<SagView>();

    constructor(
        public route: ActivatedRoute
    ) { }

    onOpenClientCase(clientCase: SagView) {
        this.openClientCase.emit(clientCase);
    }

    trackByPid(_: number, sagView: SagView) {
        return sagView.pid;
    }
}
